import { MultiSelectQuestion, QuestionProps } from '@/types/questionnaire';
import { QuestionForm } from './QuestionForm';
import { isOptionsQuestion } from './QuestionDetails';
import { useSmartQuestionUpdate } from '../hooks/useSmartQuestionUpdate';

export function EditQuestionModal({
  question,
  allQuestions,
  onClose,
}: {
  question: QuestionProps;
  allQuestions: Array<{ id: number; order: number; [key: string]: any }>;
  onClose: () => void;
}) {
  const { updateQueryMutation, handleSubmit } = useSmartQuestionUpdate({
    question,
    allQuestions,
    onClose,
  });
  return (
    <QuestionForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      isSubmitting={updateQueryMutation.isPending}
      initialData={{
        key: question.key,
        label: question.label,
        question_type: question.question_type,
        placeholder: question.placeholder,
        required: question.required,
        order: question.order,
        is_filterable: question.is_filterable,
        is_visible_to_mentors: question.is_visible_to_mentors,
        filter_display_name: question.filter_display_name,
        options: isOptionsQuestion(question) ? question.options : [],
        max_selections:
          question.question_type === 'multi_select'
            ? (question as MultiSelectQuestion).max_selections
            : undefined,
      }}
    />
  );
}
